var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeVisits(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 62.500001 62.500001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M14.608 10.447a4.152 4.152 0 0 1 4.16 4.16 4.152 4.152 0 0 1-4.16 4.161 4.152 4.152 0 0 1-4.16-4.16 4.152 4.152 0 0 1 4.16-4.16zm4.755-9.51c10.183 0 18.425 8.243 18.425 18.426 0 2.23-.417 4.354-1.145 6.336l-.178.487.102.054c-.008.064-.042.113-.042.18 0 .304.218.494.353.74l-.172.17 4.709 4.721 12.66 12.66 7.488 7.486v9.366h-8.321v-5.35c0-.977-.805-1.783-1.783-1.783h-5.35v-5.349c0-.978-.805-1.783-1.783-1.783h-6.394l-2.162-2.162-3.745-3.742-4.573-4.563-.195.098c-.266-.169-.492-.404-.836-.404-.076 0-.13.039-.202.049l-.056-.1-.476.174a18.33 18.33 0 0 1-6.324 1.14C9.179 37.788.937 29.546.937 19.363S9.18.937 19.363.937z",
    stroke: "#000",
    strokeOpacity: 1,
    fill: "none",
    strokeWidth: 1.875,
    strokeMiterlimit: 4,
    strokeDasharray: "none",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeVisits);
export default __webpack_public_path__ + "static/media/homeVisits.a52e3622ce08eb7042b0fccf058fc223.svg";
export { ForwardRef as ReactComponent };